var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 2.97498C8.16421 2.97498 8.5 3.31076 8.5 3.72498V4.97498H15.5V3.72498C15.5 3.31076 15.8358 2.97498 16.25 2.97498C16.6642 2.97498 17 3.31076 17 3.72498V4.97498H18.25C20.3211 4.97498 22 6.65391 22 8.72498V19.225C22 21.296 20.3211 22.975 18.25 22.975H5.75C3.67893 22.975 2 21.296 2 19.225V8.72498C2 6.65391 3.67893 4.97498 5.75 4.97498H7V3.72498C7 3.31076 7.33579 2.97498 7.75 2.97498ZM15.5 6.47498V7.83609C15.5 8.2503 15.8358 8.58609 16.25 8.58609C16.6642 8.58609 17 8.2503 17 7.83609V6.47498H18.25C19.4926 6.47498 20.5 7.48234 20.5 8.72498V10.975H3.5V8.72498C3.5 7.48234 4.50736 6.47498 5.75 6.47498H7V7.83609C7 8.2503 7.33579 8.58609 7.75 8.58609C8.16421 8.58609 8.5 8.2503 8.5 7.83609V6.47498H15.5ZM3.5 12.475H20.5V19.225C20.5 20.4676 19.4926 21.475 18.25 21.475H5.75C4.50736 21.475 3.5 20.4676 3.5 19.225V12.475Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendar);
export default __webpack_public_path__ + "static/media/ic_calendar.5248332d2b617237b576b4a9f2c41dea.svg";
export { ForwardRef as ReactComponent };